import {apiFetch} from "../client";

export interface BookRowPosting {
    side: "team" | "team-cashback" | "debt-correction";
    key: string;
    amount: string;
    reason: string;
}
export interface BookRowItem {
    externalId: string;
    externalOrderId?: string;
    operationType: string;
    occurredAt: string;
    mainDelta: string;
    cashbackDelta: string;
    postings: BookRowPosting[];
    canSettle: boolean;
    refusal?: string;
    postedKeys: string[];
    manualActor?: string;
    postedAt?: string;
}
export interface BookRowsResponse {
    items: BookRowItem[];
    merchantName: string;
    currency: string;
}
export function getBookRows(token: string, merchantId: string): Promise<BookRowsResponse> {
    return apiFetch(`/merchant/${encodeURIComponent(merchantId)}/book-rows`, token);
}
export function settleBookRow(token: string, merchantId: string, rowId: string, teamId: string): Promise<{status: string}> {
    return apiFetch(`/merchant/${encodeURIComponent(merchantId)}/book-rows/${encodeURIComponent(rowId)}/settle`, token,
        {method: "POST", body: JSON.stringify({teamId})});
}
